import React, { lazy, Suspense } from "react";
import { Switch, Route, Redirect } from "react-router-dom";
import Loading from "components/shared-components/Loading";
import { APP_PREFIX_PATH } from "configs/AppConfig";

export const AppViews = () => {
  return (
    <Suspense fallback={<Loading cover="content" />}>
      <Switch>
        <Route
          path={`${APP_PREFIX_PATH}/users`}
          component={lazy(() => import(`./users`))}
        />
        <Route
          path={`${APP_PREFIX_PATH}/advisor-category`}
          component={lazy(() => import(`./doctor-category`))}
        />
        <Route
          path={`${APP_PREFIX_PATH}/category-requests`}
          component={lazy(() => import(`./category-request`))}
        />
        <Route
          path={`${APP_PREFIX_PATH}/user`}
          component={lazy(() => import(`./user`))}
        />
        <Route
          path={`${APP_PREFIX_PATH}/new-advisor-category/:id/:name`}
          component={lazy(() => import(`./new-doctor-category`))}
        />
        <Route
          path={`${APP_PREFIX_PATH}/top-rated/:categoryId`}
          component={lazy(() => import(`./top-rated`))}
        />
        <Route
          path={`${APP_PREFIX_PATH}/new-advisor-category`}
          component={lazy(() => import(`./new-doctor-category`))}
        />
        <Route
          path={`${APP_PREFIX_PATH}/advisors`}
          component={lazy(() => import(`./doctors`))}
        />
        <Route
          path={`${APP_PREFIX_PATH}/withdra-request`}
          component={lazy(() => import(`./withdraw-request`))}
        />
        <Route
          path={`${APP_PREFIX_PATH}/withdraw-request-user/:email/:id`}
          component={lazy(() => import(`./withdraw-request-user`))}
        />
        <Route
          path={`${APP_PREFIX_PATH}/transaction`}
          component={lazy(() => import(`./transaction`))}
        />
        <Route
          path={`${APP_PREFIX_PATH}/settings`}
          component={lazy(() => import(`./settings`))}
        />
        <Route
          path={`${APP_PREFIX_PATH}/problem`}
          component={lazy(() => import(`./problem`))}
        />
        <Route
          path={`${APP_PREFIX_PATH}/new-image-carousel`}
          component={lazy(() => import(`./new-image-carousel`))}
        />
        <Route
          path={`${APP_PREFIX_PATH}/inactive-advisors`}
          component={lazy(() => import(`./inactive-doctors`))}
        />
        <Route
          path={`${APP_PREFIX_PATH}/latest-appointments`}
          component={lazy(() => import('./latest-appointments'))}
        />
        <Route 
          path={`${APP_PREFIX_PATH}/message`} 
          component={lazy(() => import(`./message`))} 
        />
        <Route 
          path={`${APP_PREFIX_PATH}/invoice`} 
          component={lazy(() => import(`./invoice`))} 
        />
        <Route 
          path={`${APP_PREFIX_PATH}/cancelled-invoice`} 
          component={lazy(() => import(`./cancelled-invoice`))} 
        />
        
        {/* FIX: Use exact redirect or move to very bottom with exact path */}
        <Redirect exact from={`${APP_PREFIX_PATH}`} to={`${APP_PREFIX_PATH}/users`} />
      </Switch>
    </Suspense>
  );
};

export default React.memo(AppViews);